// extracted by mini-css-extract-plugin
export default {"checkboxes":"f1nk8AXVQXXlmq9PqmkU","mfaSetupButton":"pi2asqr3SIc98CSqpwnB","emailChecked":"crFnNVwXmFDafvlyCKCX","email":"fvwaiKVhdnilF8nOqTZ_"};